var styles = {"box":"CookieModal_box_12aca_1","box-left":"CookieModal_box-left_12aca_6","box-right":"CookieModal_box-right_12aca_13","box-right__title":"CookieModal_box-right__title_12aca_17","box-right__description":"CookieModal_box-right__description_12aca_28","box-right__button":"CookieModal_box-right__button_12aca_40"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
